/* global Excel */

import { minMaxColumns } from "../utils/columnUtils";

/**
 * Selects a column range in Excel to provide visual feedback
 * when the user focuses a column input field.
 */
export async function highlightColumnRange(
  column: string,
  startRow: number,
  endRow: number
): Promise<void> {
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const range = sheet.getRange(`${column}${startRow}:${column}${endRow}`);
      range.select();
      await context.sync();
    });
  } catch {
    // Silently ignore — this is just a visual hint
  }
}

/**
 * Selects a row across the configured columns in Excel to provide
 * visual feedback when the user focuses a row input field.
 */
export async function highlightRow(
  row: number,
  columns: string[]
): Promise<void> {
  if (columns.length === 0) return;
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const [minCol, maxCol] = minMaxColumns(columns);
      const range = sheet.getRange(`${minCol}${row}:${maxCol}${row}`);
      range.select();
      await context.sync();
    });
  } catch {
    // Silently ignore — this is just a visual hint
  }
}
